export const REGEX = {
  OTP: /^\d{6}$/,
};

export const USERS_PER_PAGE = 10;
export const LEADS_PER_PAGE = 10;
export const QUERY_KEYS = {
  ROLES: "roles",
  USER_LIST: "userList",
  EMPLOYMENT_TYPES: "employmentTypes",
  PROFESSION_TYPES: "professionTypes",
  BANKING_INSURERS: "bankingInsurers",
  CITIES: "cities",
  COUNTRIES: "countries",
  GET_QUOTES: "getQuotes",
  LEAD_LIST: "leadList",
  LEAD_DETAIL: "leadDetail",
  LEAD_VIEW: "leadView",
  SESSION: "session",
};

export const USER_TYPES = [
  {
    id: 1,
    label: "Internal",
    description: "A Paisabazaar employee. No KYC is required.",
  },
  {
    id: 2,
    label: "External",
    description: "Not a Paisabazaar employee. KYC may be required.",
  },
];

export const USER_TYPE_IDS = {
  INTERNAL: 1,
  EXTERNAL: 2,
};

export const ROLE_IDS = {
  SUPER_ADMIN: 1,
  ADMIN: 2,
  SENIOR_MANAGER: 3,
  TEAM_LEAD: 4,
  AGENT: 5,
  SUB_AGENT: 6,
};

export const USER_STATUS = [
  {
    id: 1,
    name: "Pending Approval",
    color: "bg-yellow-100 text-yellow-800",
    optionColor: "bg-yellow-500",
  },
  {
    id: 2,
    name: "Active",
    color: "bg-green-100 text-green-800",
    optionColor: "bg-green-500",
  },
  {
    id: 3,
    name: "Pending Documents",
    color: "bg-blue-100 text-blue-800",
    optionColor: "bg-blue-500",
  },
  {
    id: 4,
    name: "Deactivated",
    color: "bg-gray-100 text-gray-800",
    optionColor: "bg-gray-500",
  },
  {
    id: 5,
    name: "Rejected",
    color: "bg-red-100 text-red-800",
    optionColor: "bg-red-500",
  },
];

export const USER_STATUS_IDS = USER_STATUS.reduce<Record<string, number>>(
  (accum, curr) => {
    accum[curr.name.replaceAll(" ", "_").toUpperCase()] = curr.id;
    return accum;
  },
  {},
);

export const USER_ONBOARDING_STEPS = {
  1: {
    id: "step-1",
    visibleForRole: [
      ROLE_IDS.SUPER_ADMIN,
      ROLE_IDS.ADMIN,
      ROLE_IDS.TEAM_LEAD,
      ROLE_IDS.AGENT,
      ROLE_IDS.SUB_AGENT,
    ],
  },
  2: {
    id: "step-2",
    visibleForRole: [
      ROLE_IDS.SUPER_ADMIN,
      ROLE_IDS.ADMIN,
      ROLE_IDS.TEAM_LEAD,
      ROLE_IDS.AGENT,
      ROLE_IDS.SUB_AGENT,
    ],
  },
  3: {
    id: "step-3",
    visibleForRole: [
      ROLE_IDS.SUPER_ADMIN,
      ROLE_IDS.ADMIN,
      ROLE_IDS.TEAM_LEAD,
      ROLE_IDS.AGENT,
      ROLE_IDS.SUB_AGENT,
    ],
  },
  4: {
    id: "step-4",
    visibleForRole: [
      ROLE_IDS.SUPER_ADMIN,
      ROLE_IDS.ADMIN,
      ROLE_IDS.TEAM_LEAD,
      ROLE_IDS.AGENT,
      ROLE_IDS.SUB_AGENT,
    ],
  },
};

// FIXME: HOW will you maintain the following lists?
export const PERMISSION_BY_NAME = {
  Add_Admin: 5,
  Add_Senior_Manger: 6,
  Add_Team_Leader: 7,
  Add_Agent: 8,
  Add_Sub_Agent: 9,
  Approve_Senior_Manager: 10,
  Approve_Team_Leader: 11,
  Approve_Agent: 12,
  Approve_Sub_Agent: 13,
  Dashboard: 14,
  Upload_Bank_Report: 15,
  Activate_Deactive_Users: 16,
  Change_Role: 17,
  Edit_Lead: 18,
  Create_Lead: 19,
  View_Lead: 20,
  Booking_Report: 21,
  View_User_Management: 22,
  listModules: 23,
  getActiveRoles: 24,
};

export const PARENT_ROLE = {
  [ROLE_IDS.SUPER_ADMIN]: null,
  [ROLE_IDS.ADMIN]: ROLE_IDS.SUPER_ADMIN,
  [ROLE_IDS.SENIOR_MANAGER]: ROLE_IDS.ADMIN,
  [ROLE_IDS.TEAM_LEAD]: ROLE_IDS.SENIOR_MANAGER,
  [ROLE_IDS.AGENT]: ROLE_IDS.TEAM_LEAD,
  [ROLE_IDS.SUB_AGENT]: ROLE_IDS.AGENT,
};

export const LEAD_DETAILS_STATUS = {
  PARTIAL: 1,
  COMPLETED: 2,
};

export const LEAD_STAMP_IDS = {
  LEAD_CREATED: 1,
  BANK_AND_PLAN_SELECTED: 2,
  ARN_UPDATED: 3,
  LEAD_IN_PROGRESS: 4,
  LEAD_APPROVED: 5,
  LEAD_REJECTED: 6,
};

export const COUNTRY_PRODUCT_IDs = {
  CREDIT_CARD: 7,
};

export const CREDIT_HISTORY_OPTIONS = [
  {
    name: "0-6 months",
    id: 1,
  },
  {
    name: "6-12 months",
    id: 2,
  },
  {
    name: "12+ months",
    id: 3,
  },
];

export const DD_TYPES = {
  TEXT: 2,
  DROPDOWN: 1,
};

export const DOCUMENT_TYPE_MAP = {
  EMIRATES_ID: 1,
  POS_AGREEMENT: 2,
  VISA: 3,
  PASSPORT: 4,
  STATEMENT_OF_ACCOUNT: 5,
};

export const DOCUMENT_STATUS = {
  PENDING: "pending",
  UPLOADED: "uploaded",
};

export const HOME_ROUTE = "/lead/list";
